import React from 'react';
import { StockQuantPosition } from '../../../services/stockService';

interface VirtualPositionsTableProps {
  positions: StockQuantPosition[];
  loading?: boolean;
}

export const VirtualPositionsTable: React.FC<VirtualPositionsTableProps> = ({ positions, loading = false }) => {
  return (
    <div className="w-full overflow-x-auto">
      <table className="w-full text-sm text-left text-gray-400">
        <thead className="text-xs text-gray-300 uppercase bg-gray-700/50">
          <tr>
            <th className="px-4 py-3">Symbol</th>
            <th className="px-4 py-3">Name</th>
            <th className="px-4 py-3">Side</th>
            <th className="px-4 py-3">Entry Price</th>
            <th className="px-4 py-3">Current/Exit Price</th>
            <th className="px-4 py-3">PnL</th>
            <th className="px-4 py-3">Status</th>
            <th className="px-4 py-3">Exit Reason</th>
            <th className="px-4 py-3">Time</th>
          </tr>
        </thead>
        <tbody>
          {loading ? (
            <tr>
              <td colSpan={9} className="text-center py-4">
                Loading...
              </td>
            </tr>
          ) : positions.length === 0 ? (
            <tr>
              <td colSpan={9} className="text-center py-4">
                No positions found
              </td>
            </tr>
          ) : (
            positions.map((pos) => {
              const isClosed = pos.status === 'closed';
              const pnl = pos.pnl || 0;
              const pnlColor = pnl > 0 ? 'text-red-400' : pnl < 0 ? 'text-green-400' : 'text-gray-400';

              return (
                <tr key={pos.id} className="border-b border-gray-700/30 hover:bg-gray-700/30">
                  <td className="px-4 py-3 font-medium text-white">{pos.symbol}</td>
                  <td className="px-4 py-3">{pos.name || '-'}</td>
                  <td className="px-4 py-3">
                    <span className="px-2 py-1 rounded bg-red-500/20 text-red-400 text-xs">LONG</span>
                  </td>
                  <td className="px-4 py-3">{pos.entryPrice.toFixed(2)}</td>
                  <td className="px-4 py-3">{isClosed ? pos.exitPrice?.toFixed(2) : '-'}</td>
                  <td className={`px-4 py-3 ${pnlColor}`}>
                    {isClosed ? `${pnl.toFixed(2)} (${pos.pnlPercent?.toFixed(2)}%)` : '-'}
                  </td>
                  <td className="px-4 py-3">
                    <span
                      className={`px-2 py-1 rounded text-xs ${isClosed ? 'bg-gray-600/20 text-gray-400' : 'bg-green-500/20 text-green-400'}`}
                    >
                      {pos.status.toUpperCase()}
                    </span>
                  </td>
                  <td className="px-4 py-3 text-xs text-gray-400 truncate max-w-[150px]" title={pos.exitReason || ''}>
                    {isClosed ? pos.exitReason || '-' : '-'}
                  </td>
                  <td className="px-4 py-3 text-xs text-gray-500">{new Date(pos.updatedAt).toLocaleString()}</td>
                </tr>
              );
            })
          )}
        </tbody>
      </table>
    </div>
  );
};
